import React from "react";
import "./AdmissionCriteriaModal.css";
import { admission_criteria } from "../../../config/constants";
import MessagePanel from "../../../theme/messagePanel/MessagePanel";

const AdmissionCriteriaModal = () => {
  return (
    <div className="inner-container-first admission-criteria-container">
      <div className="scrollable-inner admission-criteria-scrollable-container">
        <MessagePanel {...admission_criteria} />
      </div>
    </div>
  );
};

export default AdmissionCriteriaModal;
